export default __webpack_public_path__ + "static/media/HISTORY.006f4c83.svg";